module.exports = __webpack_public_path__ + "img/nenuphars_et_fleurs.a7fef4f2.jpg";